import SurveyIndexView from "@views/Survey/SurveyIndex.vue";
import SurveySetupView from "@views/Survey/SurveySetup.vue";
import SurveyNewView from "@views/Survey/SurveyNew.vue";
import SurveyQuestionsView from "@views/Survey/SurveyQuestions.vue";
import SurveyTargetsView from "@views/Survey/SurveyTargets.vue";
import SurveyResultsV2View from "@views/Survey/SurveyResultsV2.vue";
import SurveyProfilesView from "@views/Survey/SurveyProfiles.vue";
import SurveyShareView from "@views/Survey/SurveyShare.vue";
import SurveyLearnings from "@views/Survey/SurveyLearnings.vue";
import SurveyProgressView from "@views/Survey/SurveyProgress.vue";
import SurveyCompletionView from "@views/Survey/SurveyCompletionView.vue";
import SurveyGridsView from "@views/Survey/SurveyGrids.vue";
import QualityChecksView from "@views/Survey/QualityChecks/QualityChecksIndex.vue";
import SurveyAssistantView from "@views/Survey/SurveyAssistant.vue";
import MasterReportsIndexView from "@views/MasterReports/MasterReportsIndex.vue";
import JcdCampaignsView from "@views/JcdCampaigns/JcdCampaignsView.vue";
import JcdCampaignEditView from "@views/JcdCampaigns/JcdCampaignEdit.vue";
import JcdBenchmarksView from "@views/JcdBenchmarks/JcdBenchmarksView.vue";
import MasterReportNewView from "@views/MasterReports/MasterReportNew.vue";
import MasterReportSetupView from "@views/MasterReports/MasterReportSetup.vue";
import MasterReportSlidesView from "@views/MasterReports/MasterReportSlides.vue";
import MasterReportChartsView from "@views/MasterReports/MasterReportCharts.vue";
import ReportThemesIndexView from "@views/ReportThemes/ReportThemesIndex.vue";
import ReportThemeDetailView from "@views/ReportThemes/ReportThemeDetail.vue";
import ReportV2EditView from "@views/ReportV2Edit.vue";
import ReportV2View from "@views/ReportV2.vue";
import ReportV2NewView from "@views/ReportV2New.vue";
import ReportV2SettingsView from "@views/ReportV2Settings.vue";
import ReportV2SlidesView from "@views/ReportV2Slides.vue";
import ReportsV2IndexView from "@views/ReportsV2Index.vue";
import SurveyMailingListsView from "@views/Survey/Mailing/MailingLists/MailingListsIndex.vue";
import MailingListForm from "@views/Survey/Mailing/MailingLists/MailingListForm.vue";
import SurveyEmailCampaignsView from "@views/Survey/Mailing/EmailCampaigns/EmailCampaignsIndex.vue";
import EmailCampaignForm from "@views/Survey/Mailing/EmailCampaigns/EmailCampaignForm.vue";
import SurveyTestContactsView from "@views/Survey/Mailing/TestContacts.vue";
import TemplatesIndexView from "@views/Mailing/Templates/TemplatesIndex.vue";
import TemplateFormView from "@views/Mailing/Templates/TemplatesForm/TemplatesForm.vue";
import TemplateSettingsView from "@views/Mailing/Templates/TemplatesSettings.vue";
import DashboardView from "@views/DashboardView.vue";
import SurveyResultsSetupView from "@views/Survey/SurveyResultsSetup.vue";
import SurveyContextView from "@views/Survey/SurveyContext.vue";
import SurveyExportsIndexView from "@views/Survey/Exports/SurveyExportsIndex.vue";
import SurveyExportFormView from "@views/Survey/Exports/SurveyExportForm.vue";
import SurveyHistoView from "@views/Survey/SurveyHistoView/SurveyHistoView.vue";
import AppHeader from "@/components/App/AppHeader/AppHeader.vue";
import MCampaignIndex from "@views/Admin/MCampaignIndex.vue";
import MCampaignSettings from "@views/Admin/MCampaignSettings.vue";
import MCampaignObjectives from "@views/Admin/MCampaignObjectives/MCampaignObjectives.vue";
import CampaignTargetsAndQuotas from "@/components/MCampaign/TargetsAndQuotas/CampaignTargetsAndQuotas.vue";
import MCampaignDesign from "@views/Admin/MCampaignDesign.vue";
import MCampaignAudiences from "@/components/MCampaign/Audiences/MCampaignAudiences.vue";
import MCampaignCreatives from "@/components/MCampaign/Creatives/MCampaignCreatives.vue";
import MCampaignCreativesOverview from "@/components/MCampaign/Creatives/MCampaignCreativesOverview.vue";
import MCampaignAds from "@/components/MCampaign/MCampaignAds.vue";
import MCampaignBudgets from "@views/Admin/MCampaignBudgets.vue";
import MCampaignActions from "@views/Admin/MCampaignActions.vue";
import MCampaignPushes from "@views/Admin/MCampaignPushes.vue";
import JobsIndex from "@views/Admin/JobsIndex.vue";
import JobForm from "@views/Admin/JobForm.vue";
import SqlQuery from "@views/Admin/SqlQuery/SqlQuery.vue";
import CampaignsPivot from "@views/Admin/CampaignsPivot/CampaignsPivot.vue";
import MediaLibrary from "@views/Admin/MediaLibrary/MediaLibrary.vue";
import UsersIndex from "@views/Admin/UsersIndex/UsersIndex.vue";
import AccountsIndex from "@views/Admin/AccountsIndex.vue";
import ContractsIndex from "@views/ContractsIndex.vue";
import WebhooksIndex from "@views/Admin/WebhooksIndex/WebhooksIndex.vue";
import AnnouncementsIndex from "@views/Admin/AnnouncementsIndex/AnnouncementsIndex.vue";
import AdTemplatesIndex from "@views/Admin/AdTemplates/AdTemplatesIndex.vue";
import AdTemplateEditor from "@views/Admin/AdTemplates/AdTemplateEditor.vue";
import ChatPagesIndex from "@views/ChatPages/ChatPagesIndex.vue";
import ChatPageCustomizer from "@views/ChatPages/ChatPageCustomizer.vue";
import ForbiddenView from "@views/ForbiddenView.vue";
import NotFoundView from "@views/NotFoundView.vue";
import PricerProjectsIndex from "@views/Admin/Pricer/ProjectsIndex.vue";
import PricerIndex from "@views/Admin/Pricer/PricerIndex.vue";
import PricerProjectForm from "@views/Admin/Pricer/ProjectForm.vue";
import PricerProjectTargets from "@views/Admin/Pricer/ProjectTargets.vue";
import PricerProjectSummary from "@views/Admin/Pricer/ProjectSummary.vue";
import SurveyWeighting from "@views/Survey/SurveyWeighting.vue";
import DefaultMessagesIndex from "@views/Admin/DefaultMessagesIndex.vue";
import EpistoAiView from "@views/EpistoAi/EpistoAiView.vue";
import mockupRoutes from "@views/Mockups/mockupRoutes";
import { userType, access } from "@utils/constants/userRoles";

import { useCurrentUserStore } from "@stores/currentUser";
import { useSurveyStore } from "@stores/survey/survey";
import {
  handleRoutingError,
  fetchSurveyResources,
  handleSurveys,
  handleMCampaigns,
  handleMCampaign,
  handleJob,
  handleJobs,
  handlePricer,
  handlePricerProject,
  handlePricerProjectNew,
  handleMailingLists,
  handleMailingList,
  handleLearnings,
  handleLightMailingLists,
  handleEmailCampaigns,
  handleEmailCampaign,
  handleTemplates,
  handleTemplate,
  handleContacts,
  handleAiInsightConversations,
  handleDefaultMessages,
  handleContactAttributes,
  surveyLandingRoute,
} from "./guards";
import { isEmpty } from "@utils/toolBox";

export default [
  ...mockupRoutes,
  {
    name: "Login",
    path: "/login",
    component: () => import("@views/Auth/LoginView.vue"),
    meta: { title: "Log in - Episto", layout: "blank" },
  },
  {
    name: "ForgotPassword",
    path: "/forgot-password",
    component: () => import("@views/Auth/ForgotPasswordView.vue"),
    meta: { title: "Forgot password - Episto", layout: "blank" },
  },
  {
    name: "ResetPassword",
    path: "/reset-password",
    component: () => import("@views/Auth/ResetPasswordView.vue"),
    meta: { title: "Reset password - Episto", layout: "blank" },
  },
  {
    name: "ExpiredPassword",
    path: "/expired-password",
    component: () => import("@views/Auth/ExpiredPasswordView.vue"),
    meta: { title: "Password expired - Episto", layout: "blank" },
  },
  {
    name: "Contact",
    path: "/contact",
    component: () => import("@views/Auth/ContactView.vue"),
    meta: { title: "Contact us - Episto", layout: "blank" },
  },
  {
    name: "SharedDashboard",
    path: "/shared/dashboards/:shareToken",
    component: () => import("@views/SharedDashboardView.vue"),
    meta: { title: "Dashboard - Episto", layout: "blank", metaTags: [{ name: "robots", content: "noindex, nofollow" }] },
  },
  {
    name: "Survey",
    path: "/surveys/:token",
    components: {
      default: SurveyIndexView,
      nav: AppHeader,
    },
    meta: {
      title: "Questions",
      name: "survey",
      paramLoader: "survey",
      requiresAuth: true,
      checkSurveyAccount: true,
      noAccountCheckForSales: true,
      userTypes: [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES],
      accesses: [access.SURVEYS_WRITE, access.SURVEYS_MONITOR, access.SURVEYS_ANALYZE],
    },
    props: { default: false, nav: true },
    async beforeEnter(to) {
      try {
        if (to.name === "Survey") return { name: await surveyLandingRoute(to), params: to.params };

        await fetchSurveyResources(to);
        return true;
      } catch (error) {
        return handleRoutingError(error);
      }
    },
    children: [
      {
        name: "SurveySetup",
        path: "setup",
        component: SurveySetupView,
        meta: {
          title: "Setup",
          name: "survey",
          userTypes: [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES],
          accesses: [access.SURVEYS_WRITE],
          noAccountCheckForSales: true,
        },
      },
      {
        name: "SurveyContext",
        path: "context",
        component: SurveyContextView,
        meta: {
          title: "Context",
          name: "survey",
          userTypes: [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES],
          accesses: [access.SURVEYS_WRITE],
          noAccountCheckForSales: true,
        },
      },
      {
        name: "SurveyQuestions",
        path: "questions",
        component: SurveyQuestionsView,
        meta: {
          assistant: { scope: "questions", contextType: "survey" },
          title: "Questions",
          name: "survey",
          userTypes: [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES],
          accesses: [access.SURVEYS_WRITE, access.SURVEYS_ANALYZE],
          noAccountCheckForSales: true,
        },
        async beforeEnter(to) {
          try {
            const { isAdmin } = useCurrentUserStore();
            const { hasMailingAccess, canWriteSurvey } = useSurveyStore();
            if (isAdmin || hasMailingAccess) {
              const contactAttributesExists = await handleContactAttributes(to);
              if (contactAttributesExists instanceof Error) throw contactAttributesExists;
            }
            if (isEmpty(to.hash)) {
              to.hash = "#edit";
              to.fullPath = `${to.fullPath}#edit`;
            }
            // Without surveys.write on *this* survey, #review and #test stay
            // reachable but #edit does not
            if (!canWriteSurvey && to.hash === "#edit") {
              to.hash = "#review";
              to.fullPath = to.fullPath.replace("#edit", "#review");
            }
            return true;
          } catch (error) {
            return handleRoutingError(error);
          }
        },
      },
      {
        name: "SurveyTargets",
        path: "target",
        component: SurveyTargetsView,
        meta: {
          assistant: { scope: "targets", contextType: "survey" },
          title: "Targets & Quotas",
          name: "survey",
          userTypes: [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES],
          accesses: [access.SURVEYS_WRITE],
          noAccountCheckForSales: true,
        },
      },
      {
        name: "SurveyProfiles",
        path: "profiles",
        component: SurveyProfilesView,
        meta: {
          title: "Fake respondents",
          name: "survey",
          userTypes: [userType.SALES, userType.ADMIN, userType.SUPER_ADMIN],
          accesses: [access.SURVEYS_WRITE],
        },
      },
      {
        name: "SurveySimulation",
        path: "test",
        redirect: (to) => ({ name: "SurveyQuestions", params: to.params, hash: "#test" }),
      },
      {
        name: "SurveyCharts",
        path: "charts",
        redirect: (to) => ({ name: "SurveyResultsV2", params: to.params }),
      },
      {
        name: "SurveyResultsV2",
        path: "dashboards",
        component: SurveyResultsV2View,
        meta: {
          assistant: { scope: "dashboards", contextType: "survey" },
          title: "Dashboards",
          name: "survey",
          userTypes: [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES],
          accesses: [access.SURVEYS_ANALYZE],
          noAccountCheckForSales: true,
        },
      },
      {
        name: "SurveyResultsV2View",
        path: "dashboards/:viewToken",
        component: SurveyResultsV2View,
        meta: {
          assistant: { scope: "dashboards", contextType: "survey" },
          title: "Dashboards",
          name: "survey",
          userTypes: [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES],
          accesses: [access.SURVEYS_ANALYZE],
          noAccountCheckForSales: true,
        },
      },
      {
        name: "SurveyExports",
        path: "exports",
        component: SurveyExportsIndexView,
        meta: {
          title: "Exports",
          name: "survey",
          userTypes: [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES],
          accesses: [access.SURVEYS_ANALYZE],
          noAccountCheckForSales: true,
          metaTags: [{ name: "robots", content: "noindex, nofollow" }],
        },
      },
      {
        name: "SurveyExportNew",
        path: "exports/new",
        component: SurveyExportFormView,
        meta: {
          title: "New export",
          name: "survey",
          userTypes: [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES],
          accesses: [access.SURVEYS_ANALYZE],
          noAccountCheckForSales: true,
        },
      },
      {
        name: "SurveyExportEdit",
        path: "exports/:exportToken/edit",
        component: SurveyExportFormView,
        meta: {
          title: "Edit export",
          name: "survey",
          paramLoader: "surveyExport",
          paramKey: "exportToken",
          userTypes: [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES],
          accesses: [access.SURVEYS_ANALYZE],
          noAccountCheckForSales: true,
        },
      },
      {
        name: "SurveyShare",
        path: "link",
        component: SurveyShareView,
        meta: {
          title: "Links",
          name: "survey",
          userTypes: [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES],
          accesses: [access.SURVEYS_ANALYZE],
          noAccountCheckForSales: true,
        },
      },
      {
        name: "SurveyLearnings",
        path: "learnings",
        component: SurveyLearnings,
        meta: {
          title: "Learnings",
          name: "survey",
          userTypes: [userType.ADMIN, userType.SUPER_ADMIN],
        },
        async beforeEnter(to) {
          try {
            const learningsExists = await handleLearnings(to);
            if (learningsExists instanceof Error) throw learningsExists;
            return true;
          } catch (error) {
            return handleRoutingError(error);
          }
        },
      },
      {
        name: "SurveyProgress",
        path: "progress",
        component: SurveyProgressView,
        meta: {
          assistant: { scope: "fieldwork", contextType: "survey" },
          title: "Progress",
          name: "survey",
          userTypes: [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES],
          accesses: [access.SURVEYS_MONITOR],
          noAccountCheckForSales: true,
          metaTags: [{ name: "robots", content: "noindex, nofollow" }],
        },
      },
      {
        name: "SurveyMembers",
        path: "users",
        component: () => import("@views/Survey/SurveyMembers.vue"),
        meta: {
          title: "Members",
          name: "survey",
          userTypes: [userType.ADMIN, userType.SUPER_ADMIN],
          // Survey-scoped: checkSurveyAccount re-checks these against the
          // accesses resolved for this very survey
          accesses: [access.SURVEYS_WRITE, access.ACCOUNTS_MANAGE],
          noAccountCheckForSales: true,
        },
      },
      {
        name: "SurveyCompletion",
        path: "completion",
        component: SurveyCompletionView,
        meta: {
          assistant: { scope: "fieldwork", contextType: "survey" },
          title: "Completion",
          name: "survey",
          userTypes: [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES],
          accesses: [access.SURVEYS_ANALYZE],
          noAccountCheckForSales: true,
          metaTags: [{ name: "robots", content: "noindex, nofollow" }],
        },
      },
      {
        name: "SurveyReportsV2",
        path: "reports",
        component: ReportsV2IndexView,
        meta: {
          title: "Reports",
          name: "survey",
          userTypes: [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES],
          accesses: [access.SURVEYS_ANALYZE],
          noAccountCheckForSales: true,
          metaTags: [{ name: "robots", content: "noindex, nofollow" }],
        },
      },
      {
        name: "ReportV2New",
        path: "reports/new",
        component: ReportV2NewView,
        meta: {
          title: "New Report",
          name: "survey",
          userTypes: [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES],
          accesses: [access.SURVEYS_ANALYZE],
          noAccountCheckForSales: true,
          useGeistFont: true,
        },
      },
      {
        name: "ReportV2",
        path: "reports/:reportToken",
        component: ReportV2View,
        redirect: { name: "ReportV2Slides" },
        meta: {
          assistant: { scope: "reports", contextType: "report", contextParam: "reportToken" },
          title: "Report Builder",
          name: "survey",
          userTypes: [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES],
          accesses: [access.SURVEYS_ANALYZE],
          noAccountCheckForSales: true,
          useGeistFont: true,
        },
        children: [
          {
            name: "ReportV2Settings",
            path: "settings",
            component: ReportV2SettingsView,
            meta: {
              title: "Report Settings",
              name: "survey",
            },
          },
          {
            name: "ReportV2Slides",
            path: "slides",
            component: ReportV2SlidesView,
            meta: {
              title: "Report Slides",
              name: "survey",
            },
          },
        ],
      },
      {
        name: "ReportV2Edit",
        path: "reports/:reportToken/edit",
        component: ReportV2EditView,
        redirect: { name: "ReportV2Slides" },
        meta: {
          assistant: { scope: "reports", contextType: "report", contextParam: "reportToken" },
          title: "Report Builder",
          name: "survey",
          userTypes: [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES],
          accesses: [access.SURVEYS_ANALYZE],
          noAccountCheckForSales: true,
        },
      },
      {
        name: "SurveyResultsSetup",
        path: "results/setup",
        component: SurveyResultsSetupView,
        meta: {
          title: "Settings",
          name: "survey",
          userTypes: [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES],
          noAccountCheckForSales: true,
        },
      },
      {
        path: "interviews",
        redirect: { name: "SurveyGrids" },
      },
      {
        name: "SurveyGrids",
        path: "grids",
        component: SurveyGridsView,
        meta: {
          assistant: { scope: "interviews", contextType: "survey" },
          title: "Grids",
          name: "survey",
          userTypes: [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES],
          accesses: [access.SURVEYS_ANALYZE],
          noAccountCheckForSales: true,
        },
      },
      {
        name: "SurveyQualityChecks",
        path: "quality-checks",
        component: QualityChecksView,
        meta: {
          title: "Quality checks",
          name: "survey",
          userTypes: [userType.ADMIN, userType.SUPER_ADMIN],
        },
      },
      {
        name: "SurveyAssistant",
        path: "insights",
        component: SurveyAssistantView,
        meta: {
          title: "AI Insights",
          name: "survey",
          userTypes: [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES],
          accesses: [access.SURVEYS_ANALYZE],
          noAccountCheckForSales: true,
        },
        async beforeEnter() {
          try {
            const aiInsightConversationsExist = await handleAiInsightConversations();
            if (aiInsightConversationsExist instanceof Error) throw aiInsightConversationsExist;
            return true;
          } catch (error) {
            return handleRoutingError(error);
          }
        },
      },
      {
        name: "SurveyWeighting",
        path: "weighting",
        component: SurveyWeighting,
        meta: {
          title: "Weighting",
          name: "survey weighting",
          userTypes: [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES],
          accesses: [access.SURVEYS_ANALYZE],
          noAccountCheckForSales: true,
          metaTags: [{ name: "robots", content: "noindex, nofollow" }],
        },
      },
      {
        name: "SurveyEmailCampaigns",
        path: "mailing/campaigns",
        component: SurveyEmailCampaignsView,
        meta: {
          title: "Campaigns",
          name: "survey campaigns",
          userTypes: [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES],
          accesses: [access.SURVEYS_WRITE],
          noAccountCheckForSales: true,
          checkBrevoAccess: true,
        },
        async beforeEnter() {
          try {
            const emailCampaignsExists = await handleEmailCampaigns();
            if (emailCampaignsExists instanceof Error) throw emailCampaignsExists;
            return true;
          } catch (error) {
            return handleRoutingError(error);
          }
        },
      },
      {
        name: "EmailCampaignNew",
        path: "mailing/campaigns/new",
        component: EmailCampaignForm,
        meta: {
          title: "Campaigns",
          name: "survey campaigns",
          userTypes: [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES],
          accesses: [access.SURVEYS_WRITE],
          noAccountCheckForSales: true,
          checkBrevoAccess: true,
        },
        async beforeEnter(to) {
          const emailCampaignExists = await handleEmailCampaign(to);
          if (emailCampaignExists instanceof Error) throw emailCampaignExists;
          const lightMailingListsExists = await handleLightMailingLists();
          if (lightMailingListsExists instanceof Error) throw lightMailingListsExists;
          const templatesExists = await handleTemplates(to);
          if (templatesExists instanceof Error) throw templatesExists;
          const contactsExists = await handleContacts();
          if (contactsExists instanceof Error) throw contactsExists;
          return true;
        },
      },
      {
        name: "EmailCampaignEdit",
        path: "mailing/campaigns/:campaignToken/edit",
        component: EmailCampaignForm,
        meta: {
          title: "Campaigns",
          name: "survey campaigns",
          paramLoader: "emailCampaign",
          paramKey: "campaignToken",
          userTypes: [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES],
          accesses: [access.SURVEYS_WRITE],
          noAccountCheckForSales: true,
          checkBrevoAccess: true,
        },
        async beforeEnter(to) {
          const emailCampaignExists = await handleEmailCampaign(to);
          if (emailCampaignExists instanceof Error) throw emailCampaignExists;
          const lightMailingListsExists = await handleLightMailingLists();
          if (lightMailingListsExists instanceof Error) throw lightMailingListsExists;
          const templatesExists = await handleTemplates(to);
          if (templatesExists instanceof Error) throw templatesExists;
          const contactsExists = await handleContacts();
          if (contactsExists instanceof Error) throw contactsExists;
          return true;
        },
      },
      {
        name: "SurveyMailingLists",
        path: "mailing/lists",
        component: SurveyMailingListsView,
        meta: {
          title: "Lists",
          name: "survey lists",
          userTypes: [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES],
          accesses: [access.SURVEYS_WRITE],
          noAccountCheckForSales: true,
          checkBrevoAccess: true,
        },
        async beforeEnter() {
          try {
            const mailingListsExists = await handleMailingLists();
            if (mailingListsExists instanceof Error) throw mailingListsExists;
            return true;
          } catch (error) {
            return handleRoutingError(error);
          }
        },
      },
      {
        name: "MailingListNew",
        path: "mailing/lists/new",
        component: MailingListForm,
        meta: {
          title: "Lists",
          name: "survey lists",
          userTypes: [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES],
          accesses: [access.SURVEYS_WRITE],
          noAccountCheckForSales: true,
          checkBrevoAccess: true,
        },
        async beforeEnter(to) {
          try {
            const mailingListExists = await handleMailingList(to);
            if (mailingListExists instanceof Error) throw mailingListExists;
            return true;
          } catch (error) {
            return handleRoutingError(error);
          }
        },
      },
      {
        name: "MailingListEdit",
        path: "mailing/lists/:listToken/edit",
        component: MailingListForm,
        meta: {
          title: "Lists",
          name: "survey lists",
          paramLoader: "mailingList",
          paramKey: "listToken",
          userTypes: [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES],
          accesses: [access.SURVEYS_WRITE],
          noAccountCheckForSales: true,
          checkBrevoAccess: true,
        },
        async beforeEnter(to) {
          try {
            const mailingListExists = await handleMailingList(to);
            if (mailingListExists instanceof Error) throw mailingListExists;
            return true;
          } catch (error) {
            return handleRoutingError(error);
          }
        },
      },
      {
        name: "SurveyTestContacts",
        path: "mailing/tests",
        component: SurveyTestContactsView,
        meta: {
          title: "Test contacts",
          name: "survey mailing test contacts",
          userTypes: [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES],
          accesses: [access.SURVEYS_WRITE],
          noAccountCheckForSales: true,
          checkBrevoAccess: true,
        },
        async beforeEnter(to) {
          try {
            const contactsExists = await handleContacts();
            if (contactsExists instanceof Error) throw contactsExists;
            const contactAttributesExists = await handleContactAttributes(to);
            if (contactAttributesExists instanceof Error) throw contactAttributesExists;
            return true;
          } catch (error) {
            return handleRoutingError(error);
          }
        },
      },
    ],
  },
  {
    name: "SurveyNew",
    path: "/surveys/new",
    components: {
      default: SurveyNewView,
      nav: AppHeader,
    },
    meta: {
      title: "New survey",
      name: "new",
      class: "survey",
      requiresAuth: true,
      userTypes: [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES],
      // Creating a survey needs surveys.write on an account, not merely somewhere
      accountAccesses: [access.SURVEYS_WRITE],
    },
  },
  {
    name: "root",
    path: "/",
    components: {
      default: DashboardView,
      nav: AppHeader,
    },
    meta: {
      title: "Surveys",
      name: "root",
      userTypes: [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES],
      accesses: [access.SURVEYS_WRITE, access.SURVEYS_MONITOR, access.SURVEYS_ANALYZE],
      requiresAuth: true,
    },
    async beforeEnter(to) {
      try {
        const surveysExists = await handleSurveys(to);
        if (surveysExists instanceof Error) throw surveysExists;
        return true;
      } catch (error) {
        return handleRoutingError(error);
      }
    },
  },
  {
    name: "AccountSettings",
    path: "/account",
    components: {
      default: () => import("@views/AccountSettingsView.vue"),
      nav: AppHeader,
    },
    meta: {
      title: "Account - Episto",
      name: "account",
      requiresAuth: true,
      userTypes: [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES],
      accountAccesses: [access.ACCOUNTS_READ],
    },
  },
  {
    name: "UsersIndex",
    path: "/admin/users",
    components: {
      default: UsersIndex,
      nav: AppHeader,
    },
    meta: {
      title: "Users",
      name: "users",
      requiresAuth: true,
      userTypes: [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES],
    },
  },
  {
    name: "AccountsIndex",
    path: "/admin/accounts",
    components: {
      default: AccountsIndex,
      nav: AppHeader,
    },
    meta: {
      title: "Accounts",
      name: "accounts",
      requiresAuth: true,
      userTypes: [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES],
    },
  },
  {
    name: "RolesIndex",
    path: "/admin/roles",
    components: {
      default: () => import("@views/Admin/RolesIndex/RolesIndex.vue"),
      nav: AppHeader,
    },
    meta: {
      title: "Roles",
      name: "roles",
      requiresAuth: true,
      // Roles are platform-wide, so only super admins manage the catalog
      userTypes: [userType.SUPER_ADMIN],
    },
  },
  {
    name: "ContractsIndex",
    path: "/contracts",
    components: {
      default: ContractsIndex,
      nav: AppHeader,
    },
    meta: {
      title: "Contracts",
      name: "contracts",
      requiresAuth: true,
      userTypes: [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES],
      accountAccesses: [access.ACCOUNTS_READ],
    },
  },
  {
    name: "ChatPagesIndex",
    path: "/chat-pages",
    components: {
      default: ChatPagesIndex,
      nav: AppHeader,
    },
    meta: {
      title: "Chat pages",
      name: "chat_pages",
      requiresAuth: true,
      userTypes: [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES],
      accountAccesses: [access.SURVEYS_WRITE],
    },
  },
  {
    name: "ChatPageCustomizer",
    path: "/chat-pages/:token/customize",
    components: {
      default: ChatPageCustomizer,
      nav: AppHeader,
    },
    meta: {
      title: "Chat page",
      name: "chat_pages",
      requiresAuth: true,
      userTypes: [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES],
      accountAccesses: [access.SURVEYS_WRITE],
    },
  },
  {
    name: "WebhooksIndex",
    path: "/admin/webhooks",
    components: {
      default: WebhooksIndex,
      nav: AppHeader,
    },
    meta: {
      title: "Hooks",
      name: "webhooks",
      requiresAuth: true,
      userTypes: [userType.ADMIN, userType.SUPER_ADMIN],
    },
  },
  {
    name: "AnnouncementsIndex",
    path: "/admin/announcements",
    components: {
      default: AnnouncementsIndex,
      nav: AppHeader,
    },
    meta: {
      title: "Announcements",
      name: "announcements",
      requiresAuth: true,
      userTypes: [userType.SUPER_ADMIN],
    },
  },
  {
    name: "AdTemplatesIndex",
    path: "/admin/ad-templates",
    components: {
      default: AdTemplatesIndex,
      nav: AppHeader,
    },
    meta: {
      title: "Ad templates",
      name: "ad-templates",
      requiresAuth: true,
      userTypes: [userType.ADMIN, userType.SUPER_ADMIN],
    },
  },
  {
    name: "AdTemplateEditor",
    path: "/admin/ad-templates/:token",
    components: {
      default: AdTemplateEditor,
      nav: AppHeader,
    },
    meta: {
      title: "Ad template",
      name: "ad-templates",
      requiresAuth: true,
      userTypes: [userType.ADMIN, userType.SUPER_ADMIN],
      assistant: { scope: "ad_templates", contextType: "ad_template" },
    },
  },
  {
    name: "AdminScriptingGuidelines",
    path: "/admin/scripting-guidelines",
    components: {
      default: () => import("@views/Admin/ScriptingGuidelinesIndex.vue"),
      nav: AppHeader,
    },
    meta: {
      title: "Scripting guidelines",
      name: "scripting-guidelines",
      requiresAuth: true,
      userTypes: [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES],
    },
  },
  {
    name: "AdminDefaultMessages",
    path: "/admin/default-messages",
    components: {
      default: DefaultMessagesIndex,
      nav: AppHeader,
    },
    meta: {
      title: "Default Messages",
      name: "default-messages",
      requiresAuth: true,
      userTypes: [userType.SUPER_ADMIN],
    },
    async beforeEnter() {
      try {
        await handleDefaultMessages();
        return true;
      } catch (error) {
        return handleRoutingError(error);
      }
    },
  },
  {
    name: "MembersIndex",
    path: "/members",
    components: {
      default: UsersIndex,
      nav: AppHeader,
    },
    meta: {
      title: "Members",
      name: "members",
      requiresAuth: true,
      accountAccesses: [access.ACCOUNTS_MANAGE],
    },
  },
  {
    name: "MediaLibrary",
    path: "/admin/media-library",
    components: {
      default: MediaLibrary,
      nav: AppHeader,
    },
    meta: {
      title: "Media library",
      name: "media-library",
      requiresAuth: true,
      userTypes: [userType.ADMIN, userType.SUPER_ADMIN],
    },
  },
  {
    name: "MCampaignIndex",
    path: "/admin/m_campaigns",
    components: {
      default: MCampaignIndex,
      nav: AppHeader,
    },
    meta: {
      title: "Campaigns",
      name: "Campaigns",
      requiresAuth: true,
      userTypes: [userType.ADMIN, userType.SUPER_ADMIN],
    },
    async beforeEnter() {
      try {
        const mCampaignsExist = await handleMCampaigns();

        if (mCampaignsExist instanceof Error) throw mCampaignsExist;
        return true;
      } catch (error) {
        return handleRoutingError(error);
      }
    },
  },
  {
    name: "MCampaignBudgets",
    path: "/admin/m_campaigns/:token/budgets",
    components: {
      default: MCampaignBudgets,
      nav: AppHeader,
    },
    meta: {
      title: "Budgets",
      name: "ads",
      paramLoader: "mCampaign",
      requiresAuth: true,
      userTypes: [userType.ADMIN, userType.SUPER_ADMIN],
    },
    async beforeEnter(to) {
      try {
        const mCampaignExist = await handleMCampaign(to);
        if (mCampaignExist instanceof Error) throw mCampaignExist;
        return true;
      } catch (error) {
        return handleRoutingError(error);
      }
    },
  },
  {
    name: "MCampaignSettings",
    path: "/admin/m_campaigns/:token/setup",
    components: {
      default: MCampaignSettings,
      nav: AppHeader,
    },
    meta: {
      title: "Setup",
      name: "ads",
      paramLoader: "mCampaign",
      requiresAuth: true,
      userTypes: [userType.ADMIN, userType.SUPER_ADMIN],
    },
    async beforeEnter(to) {
      try {
        const mCampaignExist = await handleMCampaign(to);
        if (mCampaignExist instanceof Error) throw mCampaignExist;
        return true;
      } catch (error) {
        return handleRoutingError(error);
      }
    },
  },
  {
    name: "MCampaignAudiences",
    path: "/admin/m_campaigns/:token/audiences",
    components: {
      default: MCampaignAudiences,
      nav: AppHeader,
    },
    meta: {
      title: "Audiences",
      name: "ads",
      paramLoader: "mCampaign",
      requiresAuth: true,
      userTypes: [userType.ADMIN, userType.SUPER_ADMIN],
    },
    async beforeEnter(to) {
      try {
        const mCampaignExist = await handleMCampaign(to);
        if (mCampaignExist instanceof Error) throw mCampaignExist;
        return true;
      } catch (error) {
        return handleRoutingError(error);
      }
    },
  },
  {
    name: "MCampaignObjectives",
    path: "/admin/m_campaigns/:token/objectives",
    components: {
      default: MCampaignObjectives,
      nav: AppHeader,
    },
    meta: {
      title: "Objectives",
      name: "ads",
      requiresAuth: true,
      userTypes: [userType.ADMIN, userType.SUPER_ADMIN],
    },
    async beforeEnter(to) {
      try {
        const mCampaignExist = await handleMCampaign(to);
        if (mCampaignExist instanceof Error) throw mCampaignExist;
        return true;
      } catch (error) {
        return handleRoutingError(error);
      }
    },
    children: [
      {
        name: "CampaignTargets",
        path: "targets",
        component: CampaignTargetsAndQuotas,
        meta: {
          title: "Targets & Quotas",
          name: "ads",
        },
      },
    ],
  },
  {
    name: "MCampaignDesign",
    path: "/admin/m_campaigns/:token/design",
    components: {
      default: MCampaignDesign,
      nav: AppHeader,
    },
    meta: {
      title: "Design",
      name: "ads",
      requiresAuth: true,
      userTypes: [userType.ADMIN, userType.SUPER_ADMIN],
    },
    async beforeEnter(to) {
      try {
        const mCampaignExist = await handleMCampaign(to);
        if (mCampaignExist instanceof Error) throw mCampaignExist;
        return true;
      } catch (error) {
        return handleRoutingError(error);
      }
    },
    children: [
      {
        name: "MCampaignAudiences",
        path: "audiences",
        component: MCampaignAudiences,
        meta: {
          title: "Audiences",
          name: "ads",
        },
      },
      {
        name: "MCampaignCreatives",
        path: "creatives",
        component: MCampaignCreatives,
        meta: {
          title: "Creatives",
          name: "ads",
        },
      },
      {
        name: "MCampaignCreativesOverview",
        path: "overview",
        component: MCampaignCreativesOverview,
        meta: {
          title: "Creatives overview",
          name: "ads",
        },
      },
      {
        name: "MCampaignAds",
        path: "ads",
        component: MCampaignAds,
        meta: {
          title: "Campaigns",
          name: "ads",
        },
      },
    ],
  },
  {
    name: "MCampaignBudgets",
    path: "/admin/m_campaigns/:token/budgets",
    components: {
      default: MCampaignBudgets,
      nav: AppHeader,
    },
    meta: {
      title: "Budgets",
      name: "ads",
      paramLoader: "mCampaign",
      requiresAuth: true,
      userTypes: [userType.ADMIN, userType.SUPER_ADMIN],
    },
    async beforeEnter(to) {
      try {
        const mCampaignExist = await handleMCampaign(to);
        if (mCampaignExist instanceof Error) throw mCampaignExist;
        return true;
      } catch (error) {
        return handleRoutingError(error);
      }
    },
  },
  {
    name: "MCampaignActions",
    path: "/admin/m_campaigns/:token/actions",
    components: {
      default: MCampaignActions,
      nav: AppHeader,
    },
    meta: {
      title: "Actions",
      name: "ads",
      paramLoader: "mCampaign",
      requiresAuth: true,
      userTypes: [userType.ADMIN, userType.SUPER_ADMIN],
    },
    async beforeEnter(to) {
      try {
        const mCampaignExist = await handleMCampaign(to);
        if (mCampaignExist instanceof Error) throw mCampaignExist;
        return true;
      } catch (error) {
        return handleRoutingError(error);
      }
    },
  },
  {
    name: "MCampaignPushes",
    path: "/admin/m_campaigns/:token/pushes",
    components: {
      default: MCampaignPushes,
      nav: AppHeader,
    },
    meta: {
      title: "Push history",
      name: "ads",
      paramLoader: "mCampaign",
      requiresAuth: true,
      userTypes: [userType.ADMIN, userType.SUPER_ADMIN],
    },
    async beforeEnter(to) {
      try {
        const mCampaignExist = await handleMCampaign(to);
        if (mCampaignExist instanceof Error) throw mCampaignExist;
        return true;
      } catch (error) {
        return handleRoutingError(error);
      }
    },
  },
  {
    name: "JobsIndex",
    path: "/admin/jobs",
    components: {
      default: JobsIndex,
      nav: AppHeader,
    },
    meta: {
      title: "Jobs",
      name: "Jobs",
      requiresAuth: true,
      userTypes: [userType.ADMIN, userType.SUPER_ADMIN],
    },
    async beforeEnter() {
      try {
        const jobsExist = await handleJobs();
        if (jobsExist instanceof Error) throw jobsExist;
        return true;
      } catch (error) {
        return handleRoutingError(error);
      }
    },
  },
  {
    name: "JobForm",
    path: "/admin/jobs/new",
    components: {
      default: JobForm,
      nav: AppHeader,
    },
    meta: {
      title: "New job",
      name: "new",
      requiresAuth: true,
      userTypes: [userType.ADMIN, userType.SUPER_ADMIN],
    },
    async beforeEnter() {
      try {
        const surveysExists = await handleSurveys();
        if (surveysExists instanceof Error) throw surveysExists;
        const mCampaignsExist = await handleMCampaigns();
        if (mCampaignsExist instanceof Error) throw mCampaignsExist;
        return true;
      } catch (error) {
        return handleRoutingError(error);
      }
    },
  },
  {
    name: "JobEdit",
    path: "/admin/jobs/:id/edit",
    components: {
      default: JobForm,
      nav: AppHeader,
    },
    meta: {
      title: "Edit job",
      name: "edit",
      paramLoader: "job",
      paramKey: "id",
      requiresAuth: true,
      userTypes: [userType.ADMIN, userType.SUPER_ADMIN],
    },
    async beforeEnter(to) {
      try {
        const surveysExists = await handleSurveys();
        if (surveysExists instanceof Error) throw surveysExists;
        const mCampaignsExist = await handleMCampaigns();
        if (mCampaignsExist instanceof Error) throw mCampaignsExist;
        const jobsExist = await handleJobs();
        if (jobsExist instanceof Error) throw jobsExist;
        const jobExist = await handleJob(to);
        if (jobExist instanceof Error) throw jobExist;
        return true;
      } catch (error) {
        return handleRoutingError(error);
      }
    },
  },
  {
    name: "SqlQuery",
    path: "/admin/sql",
    components: {
      default: SqlQuery,
      nav: AppHeader,
    },
    meta: {
      title: "SQL",
      requiresAuth: true,
      userTypes: [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES],
    },
  },
  {
    name: "CampaignsPivot",
    path: "/admin/campaigns-pivot",
    component: CampaignsPivot,
    meta: {
      title: "Campaigns pivot",
      hideHeader: true,
      requiresAuth: true,
      userTypes: [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES],
    },
  },
  {
    name: "Templates",
    path: "/mailing/templates",
    components: {
      default: TemplatesIndexView,
      nav: AppHeader,
    },
    meta: {
      title: "Email templates",
      name: "templates",
      checkBrevoAccess: true,
      requiresAuth: true,
      userTypes: [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES],
      accesses: [access.SURVEYS_WRITE],
    },
    async beforeEnter(to) {
      try {
        const templatesExists = await handleTemplates(to);
        if (templatesExists instanceof Error) throw templatesExists;
        return true;
      } catch (error) {
        return handleRoutingError(error);
      }
    },
  },
  {
    name: "TemplateNew",
    path: "/mailing/templates/new",
    components: { default: TemplateFormView, nav: AppHeader },
    meta: {
      title: "New template",
      name: "template new",
      requiresAuth: true,
      userTypes: [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES],
      accesses: [access.SURVEYS_WRITE],
      checkBrevoAccess: true,
    },
    async beforeEnter(to) {
      try {
        const templateExists = await handleTemplate(to);
        if (templateExists instanceof Error) throw templateExists;
        return true;
      } catch (error) {
        return handleRoutingError(error);
      }
    },
  },
  {
    name: "TemplateEdit",
    path: "/mailing/templates/:token/edit",
    components: { default: TemplateFormView, nav: AppHeader },
    meta: {
      title: "Content",
      name: "template",
      paramLoader: "mailingTemplate",
      requiresAuth: true,
      userTypes: [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES],
      accesses: [access.SURVEYS_WRITE],
      checkBrevoAccess: true,
    },
    async beforeEnter(to) {
      try {
        const templateExists = await handleTemplate(to);
        if (templateExists instanceof Error) throw templateExists;
        return true;
      } catch (error) {
        return handleRoutingError(error);
      }
    },
  },
  {
    name: "TemplateSettings",
    path: "/mailing/templates/:token/setup",
    components: { default: TemplateSettingsView, nav: AppHeader },
    meta: {
      title: "Settings",
      name: "template",
      paramLoader: "mailingTemplate",
      requiresAuth: true,
      userTypes: [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES],
      accesses: [access.SURVEYS_WRITE],
      checkBrevoAccess: true,
    },
    async beforeEnter(to) {
      try {
        const templateExists = await handleTemplate(to);
        if (templateExists instanceof Error) throw templateExists;
        return true;
      } catch (error) {
        return handleRoutingError(error);
      }
    },
  },
  {
    name: "Forbidden",
    path: "/forbidden",
    components: {
      default: ForbiddenView,
      nav: AppHeader,
    },
    meta: {
      title: "Forbidden",
      name: "forbidden",
    },
  },
  {
    path: "/next/:pathMatch(.*)*",
    redirect: (to) => ({
      path:
        "/" +
        (to.params.pathMatch
          ? Array.isArray(to.params.pathMatch)
            ? to.params.pathMatch.join("/")
            : to.params.pathMatch
          : ""),
    }),
  },
  {
    name: "NotFound",
    path: "/:catchAll(.*)",
    components: {
      default: NotFoundView,
      nav: AppHeader,
    },
    meta: {
      title: "Page Not Found",
      name: "NotFound",
    },
  },
  {
    name: "PricerProjectsIndex",
    path: "/admin/pricer/projects",
    components: {
      default: PricerProjectsIndex,
      nav: AppHeader,
    },
    meta: {
      title: "Pricer",
      name: "Pricer",
      requiresAuth: true,
      userTypes: [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES],
    },
    async beforeEnter() {
      try {
        const projectsExist = await handlePricer();
        if (projectsExist instanceof Error) throw projectsExist;
        return true;
      } catch (error) {
        return handleRoutingError(error);
      }
    },
  },
  {
    name: "PricerProjectNew",
    path: "/admin/pricer/projects/new",
    components: {
      default: PricerProjectForm,
      nav: AppHeader,
    },
    meta: {
      title: "Pricer",
      name: "Pricer",
      requiresAuth: true,
      userTypes: [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES],
    },
    async beforeEnter() {
      try {
        await handlePricerProjectNew();
        return true;
      } catch (error) {
        return handleRoutingError(error);
      }
    },
  },
  {
    name: "PricerProject",
    path: "/admin/pricer/projects/:token",
    components: {
      default: PricerIndex,
      nav: AppHeader,
    },
    meta: {
      title: "Pricer",
      name: "pricer project",
      paramLoader: "pricerProject",
      requiresAuth: true,
      userTypes: [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES],
    },
    async beforeEnter(to) {
      try {
        if (to.name === "PricerProject") return { name: "PricerProjectEdit", params: to.params };

        const pricerProjectExist = await handlePricerProject(to);
        if (pricerProjectExist instanceof Error) throw pricerProjectExist;
        return true;
      } catch (error) {
        return handleRoutingError(error);
      }
    },
    children: [
      {
        name: "PricerProjectEdit",
        path: "settings",
        components: {
          default: PricerProjectForm,
          nav: AppHeader,
        },
        meta: {
          title: "Settings",
          name: "pricer project",
        },
      },
      {
        name: "PricerProjectTargets",
        path: "targets",
        components: {
          default: PricerProjectTargets,
          nav: AppHeader,
        },
        meta: {
          title: "Targets",
          name: "pricer project",
        },
      },
      {
        name: "PricerProjectSummary",
        path: "summary",
        components: {
          default: PricerProjectSummary,
          nav: AppHeader,
        },
        meta: {
          title: "Summary",
          name: "pricer project",
        },
      },
    ],
  },
  {
    name: "SurveyHistosList",
    path: "/histo",
    components: {
      default: SurveyHistoView,
      nav: AppHeader,
    },
    meta: {
      title: "Histo",
      name: "histo",
      requiresAuth: true,
      userTypes: [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES],
    },
  },
  {
    name: "JcdCampaigns",
    path: "/jcd-campaigns",
    components: {
      default: JcdCampaignsView,
      nav: AppHeader,
    },
    meta: {
      title: "Campagnes JCDecaux",
      name: "jcd-campaigns",
      requiresAuth: true,
      userFlags: ["jcd_access?"],
      useGeistFont: true,
    },
  },
  {
    name: "JcdCampaignNew",
    path: "/jcd-campaigns/new",
    components: {
      default: JcdCampaignEditView,
      nav: AppHeader,
    },
    meta: {
      title: "Nouvelle campagne JCDecaux",
      name: "jcd-campaigns",
      requiresAuth: true,
      userFlags: ["jcd_access?"],
      useGeistFont: true,
    },
  },
  {
    name: "JcdCampaignEdit",
    path: "/jcd-campaigns/:id",
    components: {
      default: JcdCampaignEditView,
      nav: AppHeader,
    },
    meta: {
      title: "Campagne JCDecaux",
      name: "jcd-campaigns",
      requiresAuth: true,
      userFlags: ["jcd_access?"],
      useGeistFont: true,
    },
  },
  {
    name: "JcdBenchmarks",
    path: "/jcd-benchmarks",
    components: {
      default: JcdBenchmarksView,
      nav: AppHeader,
    },
    meta: {
      title: "Benchmarks JCDecaux",
      name: "jcd-benchmarks",
      requiresAuth: true,
      userFlags: ["jcd_access?"],
      useGeistFont: true,
    },
  },
  {
    name: "MasterReportsIndex",
    path: "/master-reports",
    components: {
      default: MasterReportsIndexView,
      nav: AppHeader,
    },
    meta: {
      title: "Master Reports",
      name: "master-reports",
      requiresAuth: true,
      userTypes: [userType.SUPER_ADMIN],
      useGeistFont: true,
    },
  },
  {
    name: "MasterReportNew",
    path: "/master-reports/new",
    components: {
      default: MasterReportNewView,
      nav: AppHeader,
    },
    meta: {
      title: "New Master Report",
      name: "master-reports",
      requiresAuth: true,
      userTypes: [userType.SUPER_ADMIN],
      useGeistFont: true,
    },
  },
  {
    name: "MasterReportDetail",
    path: "/master-reports/:themeToken",
    redirect: (to) => ({ name: "MasterReportSetup", params: { themeToken: to.params.themeToken } }),
  },
  {
    name: "MasterReportSetup",
    path: "/master-reports/:themeToken/setup",
    components: {
      default: MasterReportSetupView,
      nav: AppHeader,
    },
    meta: {
      title: "Setup",
      name: "master-reports",
      requiresAuth: true,
      userTypes: [userType.SUPER_ADMIN],
      useGeistFont: true,
    },
  },
  {
    name: "MasterReportSlides",
    path: "/master-reports/:themeToken/slides",
    components: {
      default: MasterReportSlidesView,
      nav: AppHeader,
    },
    meta: {
      title: "Slide Templates",
      name: "master-reports",
      requiresAuth: true,
      userTypes: [userType.SUPER_ADMIN],
      useGeistFont: true,
    },
  },
  {
    name: "MasterReportCharts",
    path: "/master-reports/:themeToken/charts",
    components: {
      default: MasterReportChartsView,
      nav: AppHeader,
    },
    meta: {
      title: "Chart Templates",
      name: "master-reports",
      requiresAuth: true,
      userTypes: [userType.SUPER_ADMIN],
      useGeistFont: true,
    },
  },
  // Report Themes
  {
    name: "ReportThemesIndex",
    path: "/report-themes",
    components: { default: ReportThemesIndexView, nav: AppHeader },
    meta: {
      title: "Report Themes",
      name: "report-themes",
      requiresAuth: true,
      userTypes: [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES],
      accountAccesses: [access.SURVEYS_ANALYZE],
      useGeistFont: true,
    },
  },
  {
    name: "ReportThemeDetail",
    path: "/report-themes/:themeToken",
    components: { default: ReportThemeDetailView, nav: AppHeader },
    meta: {
      title: "Report Theme",
      name: "report-themes",
      requiresAuth: true,
      userTypes: [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES],
      accountAccesses: [access.SURVEYS_ANALYZE],
      useGeistFont: true,
    },
  },
  {
    name: "EpistoAi",
    // The token is the conversation being read, so a thread has its own URL.
    path: "/episto-ai/:token?",
    components: {
      default: EpistoAiView,
      nav: AppHeader,
    },
    meta: {
      title: "Episto AI",
      name: "episto-ai",
      requiresAuth: true,
      accesses: [access.SURVEYS_WRITE, access.SURVEYS_ANALYZE],
      assistant: { scope: "account" },
    },
  },
  // Legacy routes for backward compatibility
  {
    name: "ReportAssetsIndex",
    path: "/report-assets",
    redirect: { name: "MasterReportsIndex" },
  },
  {
    name: "AiHelper",
    path: "/ai-assistant",
    redirect: { name: "EpistoAi" },
  },
  {
    name: "AiHelperConversation",
    path: "/ai-assistant/:token",
    redirect: "/episto-ai",
  },
  {
    name: "SurveyLeadMagnets",
    path: "/lm_surveys/:token",
    components: {
      default: SurveyIndexView,
      nav: AppHeader,
    },
    meta: {
      title: "Questions",
      name: "survey",
      paramLoader: "survey",
      requiresAuth: true,
      checkSurveyAccount: true,
      noAccountCheckForSales: true,
      userTypes: [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES],
      accesses: [access.SURVEYS_WRITE, access.SURVEYS_ANALYZE],
    },
    props: { default: false, nav: true },
    async beforeEnter(to) {
      try {
        if (to.name === "Survey") return { name: "SurveyQuestions", params: to.params };

        await fetchSurveyResources(to);
        return true;
      } catch (error) {
        return handleRoutingError(error);
      }
    },
    children: [
      {
        name: "SurveyChartsLeadMagnets",
        path: "dashboards",
        component: SurveyResultsV2View,
        meta: {
          title: "Dashboards",
          name: "survey",
          userTypes: [userType.ADMIN, userType.SUPER_ADMIN, userType.SALES],
          accesses: [access.SURVEYS_ANALYZE],
          noAccountCheckForSales: true,
        },
      },
    ],
  },
];
